export default {
  overview: {
    importedCustomers: {
      title: 'Imported customers',
      tooltip:
        'Incentivize customers to join your Loyalty Rewards Program by sending them Coins.'
    },
    loyaltyProgramCustomers: {
      title: 'Loyalty Program members',
      tooltip:
        'Represents the total sum of <br/>newly joined, and existing <br/>Loyalty Rewards Program members.'
    },
    enrollmentRate: {
      title: 'Enrollment rate',
      tooltip:
        'Percentage of customers <br/>who enrolled in your loyalty <br/>program.'
    },
    status: {
      title: 'Campaign status',
      tooltip:
        'This will disable sending emails to newly imported customers. Importing new customers from your ecommerce platform will continue even if emails are no longer being sent.'
    },
    banner: {
      descriptionCreateSingle:
        '<b>new customer is waiting to be part of your Loyalty Rewards Program.</b><br/>Create the campaign and invite them by offering Coins to encourage them.',
      descriptionCreateMultiple:
        '<b>new customers are waiting to be part of your Loyalty Rewards Program.</b><br/>Create the campaign and invite them by offering Coins to encourage them.',
      descriptionEnableSingle:
        '<b>new customer is waiting to be part of your Loyalty Rewards Program.</b><br/>Enable the campaign and invite them by offering Coins to encourage them.',
      descriptionEnableMultiple:
        '<b>new customers are waiting to be part of your Loyalty Rewards Program.</b><br/>Enable the campaign and invite them by offering Coins to encourage them.',
      btn: 'Create campaign'
    },
    modals: {
      disable: {
        title: 'Disable email campaign',
        description:
          'Are you sure you want to stop sending invitation emails for your Loyalty Rewards Program to new customers in your database?',
        disclaimer:
          '<b>Keep in mind:</b> This action only disables the sending of emails — importing customers will continue to happen!'
      },
      enable: {
        title: 'Enable invite email campaign',
        description:
          'Are you sure you want to enable invitation emails for your Loyalty Rewards Program to new customers in your database?',
        disclaimer: {
          singular:
            '<b>Keep in mind:</b> You will send invites to a total of {total} new customer who was imported while this campaign was disabled. This will also begin to send invites to newly imported customers.',
          plural:
            '<b>Keep in mind:</b> You will send invites to a total of {total} new customers who were imported while this campaign was disabled. This will also begin to send invites to newly imported customers.'
        }
      },
      btnPrimary: 'Confirm',
      btnSecondary: 'Cancel'
    }
  },
  campaignSummary: {
    tooltip:
      'The amount of Coins you <br/>chose to reward customers<br/> who join your loyalty<br/> program.'
  },
  campaignSettings: {
    example: {
      title: 'Example',
      example1: {
        start: 'The customers will receive',
        end: '{coinsPluralizer} if they join your Loyalty Program'
      },
      example2: {
        start: 'The customers can pay with their ',
        end: '{coinsPluralizer} on a future purchase'
      },
      disclaimer:
        '1 Coin = {currencySymbol}1 {currencyName}. Coins cannot be cashed out — only used for purchases.'
    }
  },
  customersList: {
    title: 'Customers list - Campaign steps',
    description:
      'You have {numCustomers} customers that are not part of your reward program yet. Create a campaign to send them Coins via email and retain those customers through your reward program.',
    campaignStatus: {
      dropped:
        'This customer has disabled email communications and will not receive an invitation'
    },
    filters: {
      invitationSent: 'Invitation sent',
      emailsOpened: 'Emails opened',
      linksClicked: 'Links clicked',
      loyaltyCustomers: 'Loyalty customers',
      pendingLoyaltyCustomers: 'Pending loyalty customers',
      pendingLoyaltyCustomersTooltip:
        'These customers have not yet joined your Loyalty Rewards Program.',
      emailsNotSent: 'Emails not sent',
      emailsNotSentTooltip:
        'This customer has disabled email communications and will not receive an invitation.'
    }
  },
  failureModal: {
    title: 'Import failed',
    description: `We were unable to complete the import of your customer list.<br />Please try again.`,
    btn: 'Try again'
  }
};
